var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"votesrecord-body"},[_c('van-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{attrs:{"title":"我的视频"}},[_c('List',{attrs:{"List":_vm.vote}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }